var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-tooltip',{attrs:{"placement":"topLeft"}},[_c('template',{slot:"title"},[_c('span',[_vm._v("Visa varor som saknar streckkod")])]),(_vm.barcodeVisible)?_c('a-icon',{class:_vm.barcodeActive ? 'active': 'inactive',attrs:{"type":"barcode"},on:{"click":_vm.barcodeActiveClicked}}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }